/**
 * Custom functionality for Shop page.
 */

/* global jQuery */

const filterSort = require('../components/filter-sort-menus');

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function initNoProductsMod() {
	// If page displays no products, set menu panels to relative so they are not clipped.

	$( document ).ready(function() {
		if ($('.featured-product__chip').length == 0) {
			$('.excol-side__panel').css('position', 'relative');
		}
	});
}

exports.init = function() {
    // Shop page initialization.  $ is available here...

    filterSort.init();
    initNoProductsMod();
};